const DEFAULT_MUTATION_TIMEOUT_MS = 10_000;

type GraphQLMutationResult<TData> = {
  data?: TData | null;
  errors?: readonly { message: string }[];
};

export function withMutationTimeout<T>(
  promise: Promise<T>,
  timeoutMs = DEFAULT_MUTATION_TIMEOUT_MS,
  timeoutMessage = "Request timed out. Please check your internet connection and try again.",
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error(timeoutMessage));
    }, timeoutMs);

    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error: unknown) => {
        clearTimeout(timer);
        reject(error);
      },
    );
  });
}

export function assertGraphQLMutationResult<TData>(
  result: GraphQLMutationResult<TData>,
  fallbackMessage = "Request failed",
): asserts result is GraphQLMutationResult<TData> & { data: TData } {
  const graphQLErrors = result.errors;
  if (graphQLErrors?.length) {
    const message = graphQLErrors.map((entry) => entry.message).filter(Boolean).join(", ");
    throw new Error(message || fallbackMessage);
  }

  if (result.data == null) {
    throw new Error(fallbackMessage);
  }
}

